import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Link, Stack, Typography } from "@mui/material";
import { OpenInNew } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { ShieldOutlined, CheckCircleOutlineOutlined, FactCheckOutlined, } from "@mui/icons-material";
import MarketingFooter from "./footer";
import { CONTENT_OPTIONS } from "@src/content/marketing";
import { getContentKeys } from "@src/content/marketing";
var bulletIcons = [
    _jsx(ShieldOutlined, { color: "primary", sx: { fontSize: "30px" } }),
    _jsx(CheckCircleOutlineOutlined, { color: "primary", sx: { fontSize: "30px" } }),
    _jsx(FactCheckOutlined, { color: "primary", sx: { fontSize: "30px" } }),
];
var getBaseDomain = function () {
    var hostname = window.location.hostname;
    if (hostname.match(/dev\./)) {
        return "https://dev.pangea.cloud";
    }
    if (hostname.match(/stg\./)) {
        return "https://stg.pangea.cloud";
    }
    return "https://pangea.cloud";
};
var PangeaLayout = function (_a) {
    var _b, _c, _d;
    var contentKey = _a.contentKey, children = _a.children;
    var theme = useTheme();
    var isMedium = useMediaQuery(theme.breakpoints.up("md"));
    var hostname = getBaseDomain();
    var contentKeys = getContentKeys();
    var contentKey_ = Object.hasOwn(contentKeys, contentKey)
        ? contentKey
        : "mlp"; // default to standard content
    var formFirst = contentKey === "mlp";
    var content = CONTENT_OPTIONS[contentKey_];
    var contentOrder = formFirst ? "column-reverse" : "column";
    var logo = (_jsx(Link, { href: hostname, target: "new", children: _jsx(Box, { component: "img", width: "115px", height: "24px", src: "https://pangea-marketing.s3.us-west-2.amazonaws.com/pangea-color.svg" }) }));
    return (_jsxs(Stack, { direction: { xs: contentOrder, md: "row" }, justifyContent: { xs: "flex-end", md: "center" }, gap: { xs: formFirst ? 6 : 0, sm: 4, md: 7 }, sx: {
            minHeight: "100vh",
            backgroundColor: "#FFFFFF",
        }, children: [_jsxs(Stack, { justifyContent: "space-between", alignItems: "center", gap: 4, sx: {
                    width: { xs: "100%", md: "50%" },
                    marginTop: 4,
                    marginBottom: 4,
                }, children: [isMedium && (_jsx(Stack, { direction: "row", justifyContent: "left", sx: {
                            width: "100%",
                            maxWidth: "490px",
                            padding: "0 32px",
                        }, children: logo })), !isMedium && !formFirst && (_jsx(Stack, { direction: "row", justifyContent: "center", sx: {
                            width: "100%",
                            margin: "40px 0 0",
                        }, children: logo })), _jsxs(Stack, { justifyContent: "center", alignItems: "center", sx: {
                            maxWidth: "510px",
                            padding: { xs: "0 20px", md: "0 0 0 32px" },
                        }, children: [_jsx(Typography, { variant: "h1", mb: 1, pr: 3, sx: {
                                    fontSize: "35px",
                                    lineHeight: "43px",
                                    fontWeight: "600",
                                }, children: content.title }), _jsx(Typography, { variant: "body1", mb: 7, sx: {
                                    fontSize: "19px",
                                    lineHeight: "27px",
                                    color: "#828AA4",
                                    fontWeight: "300",
                                }, children: content.subhead }), _jsx(Stack, { gap: 4, pr: 4, children: (_b = content === null || content === void 0 ? void 0 : content.bullets) === null || _b === void 0 ? void 0 : _b.map(function (item, idx) {
                                    return (_jsxs(Stack, { direction: "row", children: [_jsx(Stack, { justifyContent: "center", alignItems: "center", mr: 2, sx: {
                                                    height: "50px",
                                                    padding: "0 10px",
                                                    borderRadius: "10px",
                                                    backgroundColor: "#F1F4F7",
                                                }, children: idx < 3 ? bulletIcons[idx] : null }), _jsxs(Stack, { children: [_jsx(Typography, { variant: "h5", sx: {
                                                            fontSize: "18px",
                                                            lineHeight: "24px",
                                                            fontWeight: "400",
                                                        }, children: item === null || item === void 0 ? void 0 : item.title }), _jsxs(Typography, { variant: "body1", sx: {
                                                            fontSize: "16px",
                                                            lineHeight: "24px",
                                                            fontWeight: "300",
                                                            color: "#767f88",
                                                        }, children: [item === null || item === void 0 ? void 0 : item.body, (item === null || item === void 0 ? void 0 : item.docsLink) && (_jsxs(_Fragment, { children: [" ", _jsxs(Link, { href: "".concat(hostname).concat(item.docsLink), target: "docs", sx: {
                                                                            display: "inline-flex",
                                                                            alignItems: "center",
                                                                        }, children: ["Docs", " ", _jsx(OpenInNew, { fontSize: "small", sx: { marginLeft: "4px" } })] })] }))] })] })] }));
                                }) }), (content === null || content === void 0 ? void 0 : content.quote) && (_jsxs(Stack, { mt: 4, p: 4, gap: "10px", sx: {
                                    width: "100%",
                                    borderRadius: "16px",
                                    background: "linear-gradient(270deg, #F7F2FF 0%, #EBFCFF 100%)",
                                    border: "2px solid",
                                    borderImageSource: "linear-gradient(90deg, #38DDFF 0%, #D6B9FF 100%)",
                                }, children: [_jsxs(Typography, { variant: "body1", sx: { fontWeight: "400", fontStyle: "italic" }, children: ["\u201C", (_c = content === null || content === void 0 ? void 0 : content.quote) === null || _c === void 0 ? void 0 : _c.text, "\u201D"] }), _jsxs(Typography, { variant: "body2", sx: { fontSize: "16px" }, children: ["\u2013 ", (_d = content === null || content === void 0 ? void 0 : content.quote) === null || _d === void 0 ? void 0 : _d.attr] })] }))] }), _jsx(Stack, { direction: "row", alignItems: "flex-start", sx: {
                            width: "100%",
                            maxWidth: "452px",
                        } }), isMedium && _jsx(MarketingFooter, {})] }), _jsxs(Stack, { justifyContent: "center", alignItems: "center", sx: {
                    width: { xs: "100%", md: "50%" },
                    backgroundColor: { xs: "transparent", md: "#F6F9FC" },
                }, children: [!isMedium && formFirst && (_jsx(Stack, { direction: "row", justifyContent: "center", sx: {
                            width: "100%",
                            margin: "40px 0",
                        }, children: logo })), _jsx(Stack, { justifyContent: "center", alignItems: "stretch", textAlign: "center", sx: {
                            width: "100%",
                            maxWidth: "384px",
                            padding: 4,
                            backgroundColor: "#FFFFFF",
                            borderRadius: "16px",
                            boxShadow: {
                                xs: "none",
                                sm: "rgba(0, 0, 0, 0.16) 0px 8px 24px 0px",
                            },
                        }, children: children }), !isMedium && (_jsx(Stack, { mt: 4, mb: 4, children: _jsx(MarketingFooter, {}) }))] })] }));
};
export default PangeaLayout;
